import React from 'react';
import { Dropdown, DropdownButton } from '../DependencyHelper';
import { toDesignation } from "../../../utils/helperServices";
import styles from './DropDownStyle.module.scss';

const DropDownComponent = (props) => {
	const { selectedValue, data, handleSelect, longest, menuClassName, id } = props;
	const checkVal = (e) => {
		handleSelect(e);
	};

	const menuWidth = ((longest + 2) * 2) / 3;
	return (
		<DropdownButton id={`drop-down-button-${id}`}
			title={selectedValue}
			alignRight
			bsPrefix={`${styles['dropdown-button']} ${props.customClass} selected-${toDesignation(selectedValue)}`}
		>
			<div style={{ width: `${menuWidth}rem`}} className={styles[menuClassName]}>
				{data.map((item, index) => {
					return (
						<Dropdown.Item
						  className={toDesignation(item.label)}
							key={index}
							eventKey={item.label}
							bsPrefix={styles['dropdown']}
							onSelect={checkVal}
							id={`${index}_${item.label}`}
						>
							<label className={styles['item']}>{item.label}</label>
						</Dropdown.Item>
					);
				})}
			</div>
		</DropdownButton>
	);
};

export default DropDownComponent;
